const SceneBase = require("./scene-base.js");

class SceneYoutube extends SceneBase {
    static type() {
        return "sceneyoutube";
    }
}

module.exports = SceneYoutube;